<template>
    <div style="width: 100%; height: 300px;display: inline-block;">
        <div :ref="setRef" style="width:100%; height:100%;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { computed, onMounted, onUnmounted, watchEffect } from "vue";
import { useStore } from 'vuex'
import Toast from 'primevue/toast';

export default {
    name: "tw-charts",
    
    setup(props) {
        let myRef;
        let myChart;

        // 主题
        const store = useStore()
        const isDark = computed(() => {
            return store.state.isDark
        })

        const setRef = el => {
            myRef = el;
        }

        // 窗口改变大小时需要刷新饼图
        const onResize = function() {
            setTimeout(() => {
                myChart.resize()
            }, 100);
        }

        onMounted(()=>{
            // echarts.registerTheme('tw_dark', twDark)
            myChart = echarts.init(myRef /*, 'tw_dark' */);

            window.addEventListener("resize", onResize)

            watchEffect(() => {
                // 指定图表的配置项和数据
                var option = {
                    title: {
                        text: props.title
                    },
                    legend: {
                        show: props.legendShow
                    },
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            color: isDark.value ? '#ebedef' : '#495057'
                        }
                    },
                    yAxis: [
                        {
                            scale: true,
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    // 使用深浅的间隔色
                                    color: [ !isDark.value ? '#ebedef' : '#495057' ],
                                    type: 'dashed'
                                }
                            },
                            axisLabel: {
                                color: isDark.value ? '#ebedef' : '#495057'
                            }
                        }
                    ],
                    dataset: {
                        source: []
                    },
                    series: []
                };

                // 当 series 中有指定使用右边刻度时，需要增加一个
                if (props.series?.find(el => el.axis_index === 1)) {
                    option.yAxis.push({
                        scale: true,
                        splitLine:{
                            show:false
                        }
                    })
                }

                const datas = props.data_source?.datas
                if (datas && Array.isArray(datas)) {
                    if (props?.series?.length) {
                        // 生成 dataset
                        const columns = props.data_source?.columns.map(el => el.field_name)
                        const source = datas.map(el => {
                            const row = []
                            columns.forEach(col => row.push(el[col]))
                            return row
                        })
                        // 不知为何，明明各项设置及数据都没有问题，但却少了第一列，所以添加一个重复的第一列
                        // option.dataset.source = source
                        if (source.length) {
                            option.dataset.source = [source[0], ...source]
                        }

                        // 生成 series
                        const series = []
                        props.series.forEach(el => {
                            const x = columns.findIndex(col => col === el.item)
                            const y = columns.findIndex(col => col === el.value)
                         
                            switch (el.type) {
                                case 'pie':
                                    series.push({
                                        name: el.name,
                                        type: el.type,
                                        radius: 45,
                                        encode: { itemName: x, value: y}
                                    })
                                    break;
                                default: {
                                    // 适用于 line\bar
                                    series.push({
                                        name: el.name,
                                        type: el.type ?? 'bar',
                                        yAxisIndex: el.axis_index,
                                        stack: el.stack,
                                        encode: { x, y}
                                    })
                                    break;
                                }
                            }
                        })
                        option.series = series
                    }
                } else {
                    if (datas) {
                        // ElMessage.error('数据源格式必须为对象数组，请检查【数据源】数据格式是否正确');
                        Toast.add({severity:'error', detail:'数据源格式必须为对象数组，请检查【数据源】数据格式是否正确'});
                    }
                }

                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            })
        })

        onUnmounted(() => {
            document.removeEventListener('resize', onResize, true)
        })

        return {
            setRef
        };

    },
    props: {
        title: String,
        legendShow: {
            type: Boolean,
            default: true
        },
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        series: {
            type: Array,
            default: function() {
                return []
            }
        }
        // series_name: {
        //     type: String,
        //     default: '',
        // },
        // caption_name: {
        //     type: String,
        //     default: ''
        // },
        // value_name: {
        //     type: String,
        //     default: ''
        // }
    }
  }
</script>

<style>

</style>